import { render, staticRenderFns } from "./preFotter.vue?vue&type=template&id=32d2de04&scoped=true&"
import script from "./preFotter.vue?vue&type=script&lang=js&"
export * from "./preFotter.vue?vue&type=script&lang=js&"
import style0 from "./preFotter.vue?vue&type=style&index=0&id=32d2de04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2de04",
  null
  
)

export default component.exports